/**
 * A single tab page. It renders the passed template
 * via the @Input properties by using the ngTemplateOutlet
 * and ngTemplateOutletContext directives.
 */

import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { TabControlComponent } from './tab-control.component';

@Component({
  selector: 'app-tab-page',
  template: `
    <div [hidden]="!isActive">
      <ng-content> </ng-content>
    </div>
  `,
})
export class TabPageComponent {
  @Input() tabName: string;
  @Input() isActive = false;

  constructor(private tabControl: TabControlComponent) {
    this.tabControl.addTab(this);
    this.tabControl.select;
  }
}
